import React from 'react';
import useBundleTranslation from 'i18n';
import { Box, Button, Typography } from '@mui/material';

import IconMi from 'components/common/icon/IconMi';
import { FormRendererAPIType } from 'components/common/form';
import { FormControlTextProps } from 'components/common/form/layout/control';
import FormTextarea from 'components/common/form/layout/control/FormTextarea';

import styles from './ExternalReportCustomUrl.styles';

interface IProps {
    url: string;
    append: string;
    form: FormRendererAPIType;
    onChange: (nextValue: string) => void;
}

const ExternalUrlForm: React.FC<IProps> = ({ form, url, onChange, append }) => {
    const { t } = useBundleTranslation(['app/editor/element/extreport']);

    const controlProps: FormControlTextProps = {
        form,
        name: 'url',
        onChange: (event) => {
            onChange(event.target.value);
        },
        label: t('url'),
        value: url,
        rows: 7,
    };

    return (
        <Box sx={styles.externalUrlForm}>
            <Typography variant="body1" gutterBottom component="div">
                {t('url')}
            </Typography>
            <FormTextarea controlProps={controlProps} />

            <Box sx={styles.externalUrlRow}>
                <a href={url + append} target="_blank" rel="noopener noreferrer">
                    <Button variant="outlined" startIcon={<IconMi icon="test" />}>
                        {t('test_url')}
                    </Button>
                </a>
            </Box>
        </Box>
    );
};

export default ExternalUrlForm;
